<template>
  <div>
    <v-dialog v-model="loading_dialog" persistent width="300">
      <v-card color="#4EBCA6" dark class="pt-1">
        <v-card-text class="text-center">
          <div class="pt-2 white--text font-16">
            กำลังเซ็นเอกสาร
          </div>
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_open" fullscreen scrollable>
      <v-card>
        <v-card-title color="#00a99d" style="background: #00a99d; height: 48px;">
          <v-row style="padding-bottom: 0.3rem;">
            <h2 style="color: white; font-size: 24px;">อนุมัติเอกสาร</h2>
            <v-spacer></v-spacer>
            <v-btn v-if="type_login == 'provider'" class="card-medium" color="#FFFFFF" @click="approveByProvider()">
              <span style="color: #00a99d;" class="font-14">อนุมัติเอกสาร</span>
            </v-btn>
            <v-btn v-else class="card-medium" color="#FFFFFF" @click="approveDoc()">
              <span style="color: #00a99d;" class="font-14">อนุมัติเอกสาร</span>
            </v-btn>
            <v-btn icon @click="closeDialog()" style="margin-left: 10px;">
              <v-icon color="#FFFFFF">mdi-close</v-icon>
            </v-btn>
          </v-row>
        </v-card-title>
        <v-card-text max-height="100vh" style="background: #CEEFED;">
          <div class="PDFsize">
            <pdf height="590px" width="600px" :src="`data:application/pdf;base64,${docPdf}`" />
            <div v-if="doc_code == 'PRESCRIPTION_CERT' && payload_success.drug_list.length > 5" class="mt-3">
              <pdf height="590px" width="600px" :src="`data:application/pdf;base64,${docPdf}`" :page="2" />
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <SetUpSignatureVue ref="setUpSignature" @Approve="approveDoc" />
  </div>
</template>

<script>
import pdf from 'vue-pdf'
import { EventBus } from "@/EventBus"
import SetUpSignatureVue from '../SetUpSignature.vue'

export default {
  components: {
    pdf,
    SetUpSignatureVue
  },
  data: () => ({
    type_login: sessionStorage.type_login,
    dialog_open: false,
    docPdf: "",
    _id: "",
    doc_code: "",
    loading_dialog: false,
    doctor_name: "",
    cid: "",
    payload_success: {}
  }),
  methods: {
    open(input) {
      // console.log(input)
      setTimeout(() => {
        document.getElementsByClassName('v-dialog--active')[0].scrollTop = 0
      }, 100)
      this.docPdf = input.pdf_data
      this._id = input.id
      this.doc_code = input.doc_code
      this.dialog_open = true
      this.doctor_name = input.doctor_name
      this.cid = input.cid
      this.payload_success = input.payload_success
    },
    closeDialog() {
      this.dialog_open = false
    },
    countThaiTextLength(text) {
      const pattern = /[\u0E01-\u0E2Eะาเโไแำๅ\s]/g; // Unicode range for Thai characters and space
      const excludedVowels = /[\u0E31\u0E34-\u0E3A]/; // Excluded vowels pattern
      let arr = text.split(" ");
      let text2 = `${arr[0]} ${arr[1]}`
      const match = text2.match(pattern);
      let count = 0;

      if (match) {
        match.forEach((character) => {
          if (!excludedVowels.test(character)) {
            count++;
          }
        });
      }

      return count;
    },
    async approveByProvider() {
      try {
        this.loading_dialog = true
        await this.axios.get(`${process.env.VUE_APP_BACKEND_URL}/v1/sign/get_sign_provider`).then((res) => {
          // console.log("res >>>", res)
          if (res.data.data) {
            this.approveDoc(res.data.data)
          } else {
            this.$swal.fire({
              icon: "error",
              title: `<span style="font-size: 20px;">ไม่พบลายเซ็นใน Provider</span>`,
              showConfirmButton: false,
              timer: 2000,
            })
          }
        })
      } catch (err) {
        this.loading_dialog = false
        this.$swal.fire({
          icon: "error",
          title: `<span style="font-size: 20px;">ไม่พบลายเซ็นใน Provider</span>`,
          showConfirmButton: false,
          timer: 2000,
        })
        console.log(err)
      }
    },
    async approveDoc(img_sign_provider = null) {
      try {
        this.loading_dialog = true
        let sign_position
        if (this.doc_code === "MEDICAL_CERTIFICATE") {
          sign_position = `0.4216867469879518,0.17,0.421,0.087`
        } else if (this.doc_code === "DRIVING_LICENSE") {
          sign_position = `0.500,0.15,0.17,0.087`
        } else if (this.doc_code === "FORMFOREINGWORKERS") {
          sign_position = `0.65,0.078,0.17,0.087`
        } else if (this.doc_code === "CONTROLLED_HERBS") {
          sign_position = `0.5300,0.1000,0.421,0.087`
        } else if (this.doc_code === "PRESCRIPTION_CERT") {
          sign_position = `0.4890,0.0310,0.421,0.087`
        } else if (this.doc_code === "COMMENT_CERT") {
          sign_position = `0.4890,0.0310,0.421,0.087`
        }

        let body = {
          id: this._id,
          doc_code: this.doc_code,
          biz_id: sessionStorage.biz_id,
          cid: this.cid,
          pdf_data: this.docPdf,
          pageToSign: 1,
          sign_position: sign_position,
          payload: this.payload_success
        }
        if (this.doc_code == "PRESCRIPTION_CERT" && this.payload_success.drug_list.length > 5) {
          body.pageToSign = 2
        }
        if (this.type_login == "provider") {
          body.type = "provider"
          body.sign_image = img_sign_provider
          body.biz_id = sessionStorage.biz_id == "341440614225692" ? "324265892276395" : sessionStorage.biz_id

          if (this.doc_code == "DRIVING_LICENSE") {
            body.doctor_data = {
              "addressLocality": this.payload_success?.address_hospital || "",
              "affiliation": this.payload_success?.name_hospital || "",
              "identifier": this.payload_success?.doctor_license || "",
              "name": this.payload_success?.name_doctor_th || ""
            }

          } else {
            body.doctor_data = {
              "addressLocality": this.payload_success?.biz?.biz_address || "",
              "affiliation": this.payload_success?.biz?.biz_name || "",
              "identifier": this.payload_success?.doctor?.doctor_license || "",
              "name": this.payload_success?.doctor?.doctor_name || ""
            }
          }
        }

        await this.axios.post(`${process.env.VUE_APP_BACKEND_URL}/v1/sign/pdfdata`, body
        ).then((res) => {
          // console.log("res >>>", res)
          this.loading_dialog = false
          // this.$refs.setUpSignature.open()
          if (res.data.result === "success") {
            this.$swal.fire({
              icon: "success",
              title: `<span style="font-size: 20px;">เซ็นเอกสารสำเร็จ</span>`,
              showConfirmButton: false,
              timer: 2000,
            })
            EventBus.$emit('getData')
            this.closeDialog()
          }
        })
      } catch (err) {
        this.loading_dialog = false
        if (err.response.data.message === "Not found credential") {
          this.$swal.fire({
            icon: "error",
            title: `<span style="font-size: 20px;">ไม่มีสิทธ์ในการเซ็นเอกสาร</span>`,
            showConfirmButton: false,
            timer: 2000,
          })
        } else if (err.response.data.message == "Patient not found") {
          this.$swal.fire({
            icon: "error",
            title: `<span style="font-size: 20px;">ไม่พบ oneid ของผู้ป่วย</span>`,
            showConfirmButton: false,
            timer: 2000,
          })
        } else if (err.response.data.message == "This user has not a signature image!!") {
          this.$refs.setUpSignature.open()
          return
        } else {
          this.$swal.fire({
            icon: "error",
            title: `<span style="font-size: 20px;">เกิดข้อผิดพลาด</span>`,
            showConfirmButton: false,
            timer: 2000,
          })
        }
        console.log(err)
      }
    }
  }
}
</script>

<style scoped>
.card-medium {
  background: #ceefed;
  border-radius: 20px 5px;
  box-shadow: none !important;
}

.PDFsize {
  padding-top: 2%;
  padding-bottom: 1%;
  padding-left: 15%;
  padding-right: 15%;
}
</style>
